import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=684ec6f8&scoped=true"
import script from "@/controllers/dashboard.js?vue&type=script&lang=js&external"
export * from "@/controllers/dashboard.js?vue&type=script&lang=js&external"
import style0 from "./Dashboard.styles.scss?vue&type=style&index=0&id=684ec6f8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684ec6f8",
  null
  
)

export default component.exports